import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import styles from "./NotFound.module.scss"
import {
  useAuthContext,
  usePolyglot,
} from "src/contexts"

const polyglotPrefix = "pages.not_found."

export function NotFound() {
  const polyglot = usePolyglot()
  const { isAuthenticated } = useAuthContext()

  const homeRoute = isAuthenticated ? "/home" : "/"

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {polyglot.t(`${polyglotPrefix}title`)}
      </div>
      <div className={styles.content}>
        <div className={styles.subtitle}>
          {polyglot.t(`${polyglotPrefix}subtitle`)}
        </div>
        <ActionLink
          stylePreset="secondary"
          asChild
        >
          <Link
            to={homeRoute}
            params={{}}
            search={{}}
          >
            {polyglot.t(`${polyglotPrefix}cta`)}
          </Link>
        </ActionLink>
      </div>
    </div>
  )
}
